import styled from 'styled-components/macro';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { getTextStyles } from '@yme/utils/styles';
export const PaymentOptionsStyled = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: ${INDENT.xs};

  ${ADAPTIVE.minWidth.tablet} {
    justify-content: start;
  }
`;
export const PaymentOptionsLabelStyled = styled.span `
  height: 28px;
  display: flex;
  align-items: center;

  ${ADAPTIVE.maxWidth.mobile} {
    display: none;
  }

  ${getTextStyles('Ubuntu', 500, 14, 20)};
  color: ${colorCoreBlack300};
`;
export const PaymentOptionsListStyled = styled.ul `
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  padding: 0;

  list-style: none;
`;
